import template from './requisition_configuration.html';
import tr from '../../lib/default-translator.js';

class RequisitionConfigurationViewModel
{
	constructor(page)
	{
		this.page = page;
		this.images_list = ko.observableArray([]);
	}

	async add_image()
	{
		await Grape.dialog.open('RequisitionConfigurationAddImage', {});
		this.page.updateData();
	}

	show_help()
	{
		Grape.dialog.open('RequisitionConfigurationHelp', { 'employee_id': this.page.bindings.id });
	}
}

class RequisitionConfigurationPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new RequisitionConfigurationViewModel(this);
	}

	init()
	{
		document.title = tr('Requisition Configuration');
		window.current_page_title(tr('Requisition Configuration'));
	}

	async updateData()
	{
		let res = await Grape.fetches.getJSON('/requisition/list_requisition_images', {});
		this.viewModel.images_list(res || []);
	}
};

export default {
	route: '[/]admin/requisition_configuration',
	page_class: RequisitionConfigurationPage,
	template: template,
	template_filename: 'translation/requisition_configuration'
};
